<template>
  <v-navigation-drawer
    overlay-opacity="0.3"
    touchless
    class="issues-drawer"
    color="accent"
    absolute
    right
    :stateless="
      $vuetify.breakpoint.smAndDown || isNotDesktop || alertDrawerClipped
    "
    :temporary="$vuetify.breakpoint.smAndDown"
    :value="getAlertDrawerValue"
    :hide-overlay="!isNotDesktop"
  >
    <template v-slot:prepend>
      <v-btn
        v-if="$vuetify.breakpoint.smAndDown || isNotDesktop"
        @click="$emit('toggle-issues-drawer', false)"
        class="absolute"
        style="left: 8px; top: 8px"
        icon
        x-small
        dark
      >
        <v-icon style="font-size: 19px !important">fas fa-times-circle</v-icon>
      </v-btn>

      <v-tooltip v-else-if="$vuetify.breakpoint.mdAndUp" bottom>
        <template v-slot:activator="{ on }">
          <v-btn
            v-on="on"
            @click="$emit('toggle-alert-drawer-clipped')"
            :color="alertDrawerClipped ? 'secondary' : 'white'"
            class="absolute"
            style="left: 8px; top: 8px"
            icon
            x-small
            dark
          >
            <v-icon style="font-size: 17px !important">fas fa-thumbtack</v-icon>
          </v-btn>
        </template>
        <span>{{ alertDrawerClipped ? "Unpin" : "Pin" }}</span>
      </v-tooltip>

      <div class="text-center" style="background: #47bd96">
        <p class="secondary-h1 py-1" style="font-size: 19px">alerts</p>
      </div>
      <v-btn
        @click="$emit('create-alert')"
        class="absolute"
        style="right: 8px; top: 8px"
        icon
        x-small
        dark
      >
        <v-icon style="font-size: 19px !important">fas fa-plus-circle</v-icon>
      </v-btn>
    </template>

    <v-list
      :key="listRenderKey"
      dense
      style="
        height: 100%;
        border-bottom: 1px solid gray;
        border-top: 1px solid gray;
      "
    >
      <div
        id="active-issues"
        style="height: 100%; overflow-y: auto !important"
        @scroll="
          (ev) =>
            syncScroll(
              'active-issue-actions',
              'active-issues',
              alertCards.length,
              ev,
              'items'
            )
        "
      >
        <v-list-item
          class="activeIssues-list-item showEnableSwitch px-0"
          @click="$emit('show-all-history')"
        >
          <v-list-item-title style="height: 30px" class="pt-2 pl-2">
            <p class="ma-0 pa-0">All</p>
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          v-for="(alertCard, index) in alertCards"
          :key="alertCard.alertStatistics.alertCardId"
          :style="
            index === alertCards.length - 1
              ? 'margin-bottom:-20px;'
              : 'opacity:1;'
          "
          class="activeIssues-list-item showEnableSwitch px-0"
          @click="() => {}"
          @mouseover="$emit('show-active-issue-actions', index)"
          @mouseout="$emit('hide-active-issue-actions', index)"
          :class="
            selectedCardId != null &&
            selectedCardId === alertCard.alertStatistics.alertCardId
              ? 'selected-issue'
              : 'supplementary-class'
          "
        >
          <v-list-item-title style="height: 30px" class="pl-2">
            <v-row justify="space-between" class="mx-0">
              <v-tooltip v-if="alertCard.alertStatistics.name.length > 17" bottom>
                <template v-slot:activator="{ on }">
                  <v-icon
                    v-on="on"
                    class="alert-card-switch show-name-of-alert-card"
                    >fas fa-caret-square-down</v-icon
                  >
                </template>
                <span>{{alertCard.alertStatistics.name}}</span>
              </v-tooltip>

              <v-row
                @click="selectCard(alertCard)"
                class="mx-0"
                style="height: 30px; max-width: 170px"
              >
                <p
                  class="ma-0 px-0 pb-0 pt-2 drawer-char-lim"
                  :class="{ 'grey--text': !alertCard.alertStatistics.enabled }"
                >
                  {{ alertCard.alertStatistics.name }}
                </p>
                <v-spacer></v-spacer>
              </v-row>
              <v-switch
                v-model="alertCard.alertStatistics.enabled"
                @change="$emit('alert-card-action', alertCard)"
                small
                hide-details
                color="primary"
                class="always-primary-checkbox alert-card-switch mt-0 pt-3 pb-1 mr-1"
                style="width: 40px; height: 30px"
              ></v-switch>
              <v-badge
                v-if="alertCard.alertStatistics.totalAlerts > 0"
                :content="
                  alertCard.alertStatistics.totalAlerts < 100
                    ? alertCard.alertStatistics.totalAlerts
                    : '99+'
                "
                class="mr-8 mt-5"
              ></v-badge>
              <div v-else style="width: 32px"></div>
            </v-row>
          </v-list-item-title>
        </v-list-item>
      </div>
    </v-list>
  </v-navigation-drawer>
</template>

<script>
import {syncScroll} from "@/utilities/tradewatcher-helpers";
export default {
  data() {
    return {
      syncScroll: syncScroll,
      selectedCardId: null,
      listRenderKey: 0,
    };
  },
  methods: {
    rerenderList() {
      this.listRenderKey > 2 ? (this.listRenderKey = 0) : this.listRenderKey++;
    },
    selectCard(issue) {
      this.selectedCardId = issue.alertCardId;
      this.$emit("card-selected", {
        id: issue.alertStatistics.alertCardId,
        name: issue.alertStatistics.name,
      });
    },
  },
  props: {
    getAlertDrawerValue: {
      type: Boolean,
      default: false,
    },
    isNotDesktop: {
      type: Boolean,
      default: false,
    },
    alertDrawerClipped: {
      type: Boolean,
      default: false,
    },
    alertCards: {
      type: Array,
      default: () => [],
    },
  },
};
</script>
<style>
.drawer-char-lim {
  max-width: 202px;
  overflow: hidden;
  white-space: nowrap;
  text-overflow: ellipsis;
}
</style>
